
export const fastingBenefits = [
  {
    title: 'Weight Loss',
    description: 'Fasting helps reduce calorie intake and improves hormone function to facilitate weight loss. It increases metabolic rate and helps preserve muscle tissue during weight loss.'
  },
  {
    title: 'Improved Insulin Sensitivity',
    description: 'Fasting can reduce insulin resistance, lowering blood sugar levels and protecting against type 2 diabetes. It allows your body to use insulin more effectively.'
  },
  {
    title: 'Enhanced Brain Function',
    description: 'Fasting increases brain-derived neurotrophic factor (BDNF), which may aid brain function and protect against neurodegenerative diseases.'
  },
  {
    title: 'Cellular Repair (Autophagy)',
    description: 'During fasting, cells initiate cellular repair processes, removing waste material from cells, which may help prevent cancer and slow aging.'
  },
  {
    title: 'Reduced Inflammation',
    description: 'Studies show fasting can reduce oxidative stress and inflammation in the body, improving overall health and protecting against various diseases.'
  },
  {
    title: 'Heart Health',
    description: 'Fasting improves various risk factors for heart disease like blood pressure, cholesterol levels, triglycerides, and inflammatory markers.'
  },
  {
    title: 'Cancer Risk Reduction',
    description: 'Fasting may help lower risk factors for certain cancers by reducing inflammation, insulin levels, and factors that promote tumor growth.'
  },
  {
    title: 'Liver Health',
    description: 'Intermittent fasting can reduce liver fat, improve enzyme levels, and enhance the liver\'s ability to detoxify the body.'
  },
  {
    title: 'Longevity',
    description: 'Some research suggests that fasting may activate pathways that can contribute to a longer lifespan through cellular stress resistance and improved metabolic health.'
  }
];

export const fastingStages = [
  {
    timeRange: '0-4 Hours',
    title: 'Digestion Phase',
    description: 'Your body is digesting and absorbing nutrients from your last meal.',
    effects: [
      'Blood glucose levels remain steady',
      'Insulin levels are elevated to facilitate nutrient absorption',
      'Energy is derived primarily from recently consumed food'
    ]
  },
  {
    timeRange: '4-8 Hours',
    title: 'Post-Absorptive Phase',
    description: 'Your body begins to transition away from using recently consumed food for energy.',
    effects: [
      'Blood glucose gradually begins to drop',
      'Insulin levels start to decline',
      'Glycogen (stored carbohydrates) begin to be utilized'
    ]
  },
  {
    timeRange: '8-12 Hours',
    title: 'Glycogen Depletion',
    description: 'Your liver glycogen stores are being depleted to maintain blood glucose levels.',
    effects: [
      'Glucagon hormone increases to facilitate glycogen breakdown',
      'Fat burning begins to increase',
      'Some people experience hunger pangs during this transition'
    ]
  },
  {
    timeRange: '12-16 Hours',
    title: 'Fat Burning Mode',
    description: 'Your body has shifted to using fat as the primary fuel source.',
    effects: [
      'Significant increase in fat oxidation',
      'Ketone production begins to rise',
      'Many experience mental clarity as ketones fuel the brain'
    ]
  },
  {
    timeRange: '16-24 Hours',
    title: 'Deep Ketosis & Autophagy',
    description: 'Cellular cleaning and repair processes are enhanced during this period.',
    effects: [
      'Autophagy (cellular cleanup) increases significantly',
      'Higher ketone levels for brain function',
      'Growth hormone secretion increases',
      'Reduced inflammation markers'
    ]
  },
  {
    timeRange: '24+ Hours',
    title: 'Extended Benefits',
    description: 'Longer fasts provide additional benefits but should be approached cautiously.',
    effects: [
      'Further enhanced autophagy',
      'Stem cell regeneration begins to increase',
      'Significant insulin sensitivity improvement',
      'Should be done with proper knowledge and possibly medical supervision'
    ]
  }
];

export const fastingTips = [
  {
    title: 'Start Gradually',
    description: 'Begin with shorter fasting periods (12-14 hours) and gradually work your way up to longer durations as your body adapts.'
  },
  {
    title: 'Stay Hydrated',
    description: 'Drink plenty of water during your fast. Black coffee and unsweetened tea are also generally acceptable and can help manage hunger.'
  },
  {
    title: 'Time Your Fast Wisely',
    description: "Include sleeping hours in your fasting window. For example, if you finish dinner at 8 PM and sleep until 6 AM, you're already 10 hours into your fast when you wake up."
  },
  {
    title: 'Break Your Fast Wisely',
    description: "Don't overeat when breaking your fast. Start with a small, balanced meal and wait 30 minutes before eating more if still hungry."
  },
  {
    title: 'Listen to Your Body',
    description: "If you feel unwell during a fast (beyond normal hunger), it's okay to break it. Fasting isn't appropriate for everyone, especially those with certain medical conditions."
  },
  {
    title: 'Quality Still Matters',
    description: "During eating windows, focus on nutritious whole foods. Fasting isn't a free pass to eat unhealthy foods during your eating window."
  },
  {
    title: 'Stay Active',
    description: 'Light to moderate exercise during fasting is generally fine and can enhance fat burning. However, intense workouts are best scheduled closer to your eating window.'
  }
];
